import { render, staticRenderFns } from "./ObservationsWrapper.vue?vue&type=template&id=24633f3b&scoped=true&"
import script from "./ObservationsWrapper.vue?vue&type=script&lang=js&"
export * from "./ObservationsWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ObservationsWrapper.vue?vue&type=style&index=0&id=24633f3b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24633f3b",
  null
  
)

export default component.exports